import React from 'react'

import { useWizard, WizardProvider } from './useWizard'

export const Wizard = ({ data, steps, onStep, onFinish, children, ...props }) => {
  const context = useWizard({ data, steps, onStep, onFinish })

  return <WizardProvider value={context}>{children}</WizardProvider>
}

export default Wizard
